import React, { useEffect } from 'react'
import { useState, useRef } from "react";
import { Box, Button, Divider, TextField } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";
import styles from "./TextArea.module.css";
import styled from 'styled-components';
import { toast } from 'react-toastify';
import CommonToolTip from '../../Utils/CommonToolTip';

const social_icon = { 4: 'NewPost/facebook.svg', 5: 'NewPost/instagram.svg', 6: 'NewPost/x-icon.svg', 8: 'NewPost/linkedin.svg' };

const emojis = [
  "😀", "😁", "😂", "🤣", "😃", "😄", "😅", "😆", "😉", "😊", "😋", "😎", "😍", "😘",
  "😗", "😙", "😚", "🙂", "🤗", "🤔", "😐", "😑", "😶", "🙄", "😏", "😣", "😥", "😮",
  "🤐", "😯", "😪", "😫", "😴", "😌", "🤓", "😛", "😜", "😝", "🤤", "😒", "😓", "😔",
  "😕", "🙃", "🤑", "😲", "☹️", "🙁", "😖", "😞", "😟", "😤", "😢", "😭", "😦", "😧",
  "😨", "😩", "🤯", "😬", "😰", "😱", "🥵", "🥶", "😳", "🤪", "😵", "😡", "😠", "🤬",
  "😷", "🤒", "🤕", "🤢", "🤮", "🤧", "😇", "🥳", "🥴", "🥺", "🤠", "🤡", "🤥", "🤫",
  "🤭", "🧐", "🤓", "😈", "👿", "👹", "👺", "💀", "👻", "👽", "🤖", "💩", "😺", "😸",
  "😹", "😻", "😼", "😽", "🙀", "😿", "😾"
];

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const selectColour = { 4: '#1877F2', 6: 'black', 5: '#F00276', 8: '#0077B5' };
const isSocialCharLimit = { 4: 63206, 5: 2200, 6: 280, 8: 3000 };

const title = {
  4: "Facebook Profile: Character count can’t exceed 63206 characters for Facebook Profile.",
  5: "Instagram Profile: Character count can’t exceed 2200 characters for Instagram Profile.",
  6: "X Profile: Character count can’t exceed 280 characters for X Profile.",
  8: "LinkedIn Profile: Character count can’t exceed 3000 characters for LinkedIn Profile."
};

const minimumOneImageAlart = ["Instagram Profile:Upload a minimum of one image to post"]
const enderminimumText = ["Posts can’t be published without any text or media."]
const instagramImageLimit = ["Instagram Profile: Only 10 images allowed"]
const facebookImageLimit = ["FaceBook Profile: Only 10 images allowed"]
const linkedInImageLimit = ["LinkedIn Profile: Only 9 images allowed"]
const XImageLimit = ["X Profile: Only 4 images allowed"]

const X_ImageSize = ["X account only allows images up to 5MP in size."]
const Instagram_ImageSize = ["X account only allows images up to 5MP in size."]
const FaceBook_ImageSize = ["X account only allows images up to 5MP in size."]
const Empty_Text_Box = ["Please include some text in the text box before post "]


const TextArea = ({ formDetails, selectedPage, selectedPages, posts, setPosts, fileId, handleUpload, handleRemoveImage, handleEmojiClick, handleBlur, handlePost, integrateSocialAccount, loading, setTextCount }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [height, setHeight] = useState(0);
  const [fillterArray, setfillterArray] = useState([]);

  const popupRef = useRef(null);
  const inputRef = useRef(null);

  const socialIcon = process.env.REACT_APP_IMAGE_URL + social_icon[selectedPage?.channelType];
  const channelTypes = selectedPages.map(item => item.channelType);

  const instagramIn = channelTypes.includes(5);
  const FaceBookIn = channelTypes.includes(4);
  const LinkedInIn = channelTypes.includes(8);
  const XIn = channelTypes.includes(6);
  const oneImageadd = instagramIn && fileId.length <= 0;



  useEffect(() => {

    let newFilter = [];

    // Handle minimum one image alert in insta
    if (oneImageadd) {

      minimumOneImageAlart.forEach(item => {
        if (!newFilter.includes(item)) {
          newFilter.push(item);
        }
      });
    }
    if(posts.length===0){
      newFilter.push(...Empty_Text_Box);
    }

    formDetails?.image_data?.forEach(image => {
      if (image?.size > 5000000) {
        XIn && newFilter.push(...X_ImageSize);
      }
      if (image?.size > 8000000) {
        instagramIn && newFilter.push(...Instagram_ImageSize);
      }
      if (image?.size > 15000000) {
        FaceBookIn && newFilter.push(...FaceBook_ImageSize);
      }
    });
    formDetails?.image_data?.forEach(image => {
      if (image?.height > 30000 || image?.width > 30000) {
        XIn && newFilter.push(...X_ImageSize);
      }
    });


    // Handle image limit logic
    if (fileId.length > 4) {
      XIn && newFilter.push(...XImageLimit);
    }

    if (fileId.length > 9) {
      LinkedInIn && newFilter.push(...linkedInImageLimit);
    }

    if (fileId.length > 10) {
      instagramIn && newFilter.push(...instagramImageLimit);
      FaceBookIn && newFilter.push(...facebookImageLimit);
    }

    setfillterArray(newFilter);
  }, [oneImageadd, fileId.length]);


  // Filter out only those types from channelTypes that exist in isSocialCharLimit
  const validTypes = channelTypes.filter(type => isSocialCharLimit.hasOwnProperty(type));

  // Find the type with the minimum character limit
  const minCharLimitType = validTypes.reduce((minType, currentType) => {
    return isSocialCharLimit[currentType] < isSocialCharLimit[minType] ? currentType : minType;
  });

  // Get the character limit
  const minCharLimit = isSocialCharLimit[minCharLimitType];

  const exceededTitles = channelTypes
    .filter((type) => posts.length > isSocialCharLimit[type])
    .sort((a, b) => isSocialCharLimit[a] - isSocialCharLimit[b]) // smallest limits first
    .map((type) => title[type]);

  fillterArray.length > 0 && exceededTitles.push(...fillterArray);

  const tooltipContent = (
    <div style={{ padding: '10px' }}>
      {[...new Set(exceededTitles)].map((t, idx) => (
        <div style={{ display: 'flex' }} key={idx}>
          <div style={{ padding: '5px' }}> • </div>
          <div style={{ padding: '5px' }}>{t}</div>
        </div>
      ))}
    </div>
  );


  const handleChange = (e) => {
    const count = e.target.value.replace(/\s/g, '').length
    setTextCount(count)
    setPosts(e.target.value);
    if (inputRef.current) {
      setHeight(inputRef.current.scrollHeight);
    }
  };



  return (
    <Box sx={{ display: 'flex', flexDirection: "column", height: 'calc(100% - 80px)' }}>
      <Box sx={{ display: 'flex', overflowY: 'auto' }}>{selectedPage && <img src={socialIcon} className={styles.selected_icon_img} style={{ backgroundColor: `${selectColour[selectedPage?.channelType]}` }} alt="social_icon" />}
        <Box className={styles.text_field} onBlur={handleBlur} sx={{}} id='aaa'>
          <TextField
            className={styles.text_hightset}
            variant="outlined"
            value={posts}
            inputRef={inputRef}
            onChange={handleChange}
            placeholder="Start writing"
            multiline
            minRows={6}
            fullWidth
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                "& fieldset.MuiOutlinedInput-notchedOutline": { border: "none" },
                fontSize: "14px",
                paddingLeft: "10px",
                border: '1px solid #E6E7E9',
                borderBottom: 'unset'
              },
            }}
          />

          {/* Image Upload & Display */}
          <Box className={styles.post_upload_wrap}>
            {fileId.map((img, i) => (
              <Box key={i} className={styles.post_img_container}>
                <img
                  src={`${process.env.REACT_APP_SOCIAL_ATTACHMENT_DRIVE}?file_id=${img}`}
                  alt="post_img"
                  className={styles.post_images}
                />
                <img
                  onClick={() => handleRemoveImage(img)}
                  src={process.env.REACT_APP_IMAGE_URL + 'NewPost/cancel.svg'}
                  className={styles.remove_icon}
                  alt="remove_icon"
                />
              </Box>
            ))}
            <Box className={styles.drop_img}>
              <label style={{ cursor: 'pointer' }}>
                <ImageIcon sx={{ marginBottom: '4px' }} />
                <Box className={styles.drop_img_text}>Drag & drop or <span className={styles.drop_img_select_text}>select a file</span></Box>
                <VisuallyHiddenInput type="file" onChange={(e) => handleUpload(e)} multiple />
              </label>
            </Box>
          </Box>

          {/* Emoji & Media Icons */}
          <Box className={styles.upload_stickers}>
            <label style={{
              cursor: "pointer", display: "inline-block",
              padding: '10px',
              display: 'flex', alignItems: 'center',
              justifyContent: 'center',
            }}>
              <img
                style={{ width: '18px', height: '18px' }}
                src={process.env.REACT_APP_IMAGE_URL + "NewPost/media-connect.svg"}
                alt="media_connect_icon"
              />
              <VisuallyHiddenInput
                type="file"
                onChange={(e) => handleUpload(e.target.files[0])}
                multiple
              />
            </label>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Box className={styles.divider} />
            <Box className={styles.emoji_icon_wrap} onClick={() => setShowPopup(true)}>
              <img src={process.env.REACT_APP_IMAGE_URL + "NewPost/emoji.svg"} className={styles.social_icon_img} alt="emoji_icon" />
            </Box>
          </Box>

          {/* Emoji Popup */}
          {showPopup && (
            <Box className={styles.emoji_popup} ref={popupRef}>
              {emojis.map((emoji, index) => (
                <span key={index} className={styles.emoji_option} onClick={() => { handleEmojiClick(emoji); setShowPopup(false) }}>
                  {emoji}
                </span>
              ))}
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', padding: "20px 0px", gap: '10px' }}>
        {(posts?.length >= minCharLimit || exceededTitles.length > 0) &&
          // <CommonToolTip title={`Character count can't exceed ${isSocialCharLimit[selectedPage?.channelType]} characters`} placement="top"
          <CommonToolTip title={tooltipContent} placement="top"
            component=
            {<Box className={styles.error_icon}> <img src={process.env.REACT_APP_IMAGE_URL + "NewPost/error-icon.svg"} className={styles.social_icon_img} alt="emoji_icon" /></Box>}
          />}
        <Button variant="contained" className={styles.post_btn} onClick={handlePost} sx={{ textTransform: 'capitalize' }} disabled={!integrateSocialAccount || loading || oneImageadd || posts?.length >= minCharLimit}>Post</Button>
      </Box>
    </Box>
  );
};

export default TextArea;